















import UserTaskModel from "@/models/UserTaskModel";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({ name: "usertask-record" })
export default class UserTaskRecord extends Vue {
    @Prop(Object)
    readonly userTask!: UserTaskModel;
    @Prop(Boolean)
    readonly readonly!: boolean;

    gotoTask(): void {
        if (this.readonly) {
            return;
        }

        var url = this.userTask.url.replace('{externalId}', this.userTask.externalId);
        if (url.includes('?')) {
            url = url + "&returnUrl=" + encodeURIComponent(window.location.href);
        } else {
            url = url + "?returnUrl=" + encodeURIComponent(window.location.href);
        }

        window.location.href = url;
    }
}
